// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import QuotePage from "./components/QuotePage";
import AdminPage from "./pages/AdminPage";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<QuotePage />} />
        <Route path="/login" element={<Login />} />
        <Route 
          path="/admin" 
          element={
            <PrivateRoute>
              <AdminPage />
            </PrivateRoute>
          } 
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
